module.exports = __webpack_public_path__ + "static/media/raychem-catalog-pl.c6f1b3b2.pdf";